export default __webpack_public_path__ + "static/media/download_file.daf54347.svg";